<template>
    <b-container>
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Códigos Promocionales</h4>

        <b-row class="justify-content-center">
            <b-col cols="12" lg="3" class="mt-4 mb-2">
                <b-button variant="default" pill block size="sm" title="Nuevo código" @click="openModal()" v-b-modal.promo-modal>
                    <i class="material-icons mdi mdi-plus-circle"></i>&nbsp;
                    <span>Nuevo Código</span>
                </b-button>
            </b-col>
            <b-col cols="12" lg="6" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input v-model="search" type="search" placeholder="Buscar código o descripción" class="pad-3-15 btlr-30 bblr-30" @keyup.enter="load"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''; load();" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="3" class="mt-4 mb-2">
                <b-form-select v-model="statusFilter" :options="statusOptions" size="sm" @change="load"></b-form-select>
            </b-col>

            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    empty-text="No hay códigos promocionales"
                    :busy="loading">

                    <template #cell(code)="row">
                        <strong>{{ row.item.code }}</strong>
                    </template>

                    <template #cell(discount_percent)="row">
                        {{ Number(row.item.discount_percent).toFixed(2) }}%
                    </template>

                    <template #cell(validity)="row">
                        <span v-if="row.item.valid_from || row.item.valid_to">
                            {{ row.item.valid_from ? formatDate(row.item.valid_from) : '—' }}
                            →
                            {{ row.item.valid_to ? formatDate(row.item.valid_to) : '—' }}
                        </span>
                        <span v-else class="text-muted">Sin restricción</span>
                    </template>

                    <template #cell(uses)="row">
                        {{ row.item.uses_count }} / {{ row.item.max_uses ?? '∞' }}
                    </template>

                    <template #cell(is_active)="row">
                        <b-badge :variant="row.item.is_active ? 'success' : 'secondary'">
                            {{ row.item.is_active ? 'Activo' : 'Inactivo' }}
                        </b-badge>
                    </template>

                    <template #cell(actions)="row">
                        <b-button variant="default" size="sm" title="Editar" @click="openModal(row.item)" v-b-modal.promo-modal>
                            <i class="material-icons">edit</i>
                        </b-button>
                        <b-button :variant="row.item.is_active ? 'warning' : 'success'" size="sm"
                                  :title="row.item.is_active ? 'Desactivar' : 'Activar'" @click="toggle(row.item.id)">
                            <i class="material-icons">{{ row.item.is_active ? 'pause' : 'play_arrow' }}</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Cargando...</strong>
                        </div>
                    </template>
                </b-table>

                <!-- Modal crear/editar -->
                <b-modal
                    id="promo-modal"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    :title="(form.id ? 'Editar' : 'Nuevo') + ' Código Promocional'"
                    size="lg">
                    <b-form @submit.stop.prevent="submit">
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="6">
                                <b-form-group label="Código:">
                                    <b-form-input v-model="form.code" placeholder="PROMO20" :disabled="!!form.id" required
                                                  @input="form.code = form.code.toUpperCase()"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-form-group label="Descuento (%):">
                                    <b-form-input v-model.number="form.discount_percent" type="number" min="0.01" max="100" step="0.01" required></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12">
                                <b-form-group label="Descripción (opcional):">
                                    <b-form-input v-model="form.description" placeholder="Promoción día de la madre" maxlength="255"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-form-group label="Vigente desde:">
                                    <b-form-input v-model="form.valid_from" type="date"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-form-group label="Vigente hasta:">
                                    <b-form-input v-model="form.valid_to" type="date"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-form-group label="Máximo de usos (vacío = ilimitado):">
                                    <b-form-input v-model.number="form.max_uses" type="number" min="1"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6" class="d-flex align-items-center">
                                <b-form-checkbox v-model="form.is_active">Activo</b-form-checkbox>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="10" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill class="align-middle px-5" :disabled="saving">
                                    <b-spinner small type="grow" v-if="saving"></b-spinner>
                                    <b-icon icon="upload" v-else></b-icon>
                                    &nbsp;<span>{{ saving ? 'Guardando...' : (form.id ? 'Actualizar' : 'Crear') }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from 'axios';

export default {
    name: 'PromoCodes',
    data() {
        return {
            items: [],
            loading: false,
            saving: false,
            search: '',
            statusFilter: 'all',
            statusOptions: [
                { value: 'all', text: 'Todos' },
                { value: 'active', text: 'Activos' },
                { value: 'inactive', text: 'Inactivos' },
            ],
            fields: [
                { key: 'code', label: 'Código' },
                { key: 'discount_percent', label: 'Descuento', class: 'text-right' },
                { key: 'description', label: 'Descripción' },
                { key: 'validity', label: 'Vigencia', class: 'text-center' },
                { key: 'uses', label: 'Usos', class: 'text-center' },
                { key: 'is_active', label: 'Estado', class: 'text-center' },
                { key: 'actions', label: '', class: 'text-right' },
            ],
            form: this.emptyForm(),
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        emptyForm() {
            return {
                id: null,
                code: '',
                discount_percent: null,
                description: '',
                valid_from: null,
                valid_to: null,
                max_uses: null,
                is_active: true,
            };
        },
        async load() {
            this.loading = true;
            try {
                const res = await axios.get('/api/admin/promo-codes', {
                    params: { search: this.search, status: this.statusFilter },
                });
                this.items = res.data?.data || res.data || [];
            } catch (e) {
                this.items = [];
                this.$bvToast.toast('No se pudieron cargar los códigos.', { title: 'Error', variant: 'danger' });
            } finally {
                this.loading = false;
            }
        },
        openModal(item = null) {
            this.form = item ? {
                id: item.id,
                code: item.code,
                discount_percent: parseFloat(item.discount_percent),
                description: item.description,
                valid_from: item.valid_from ? item.valid_from.substring(0, 10) : null,
                valid_to: item.valid_to ? item.valid_to.substring(0, 10) : null,
                max_uses: item.max_uses,
                is_active: !!item.is_active,
            } : this.emptyForm();
        },
        async submit() {
            this.saving = true;
            try {
                const payload = {
                    code: this.form.code,
                    discount_percent: this.form.discount_percent,
                    description: this.form.description,
                    valid_from: this.form.valid_from,
                    valid_to: this.form.valid_to,
                    max_uses: this.form.max_uses,
                    is_active: this.form.is_active,
                };
                if (this.form.id) {
                    await axios.put(`/api/admin/promo-codes/${this.form.id}`, payload);
                } else {
                    await axios.post('/api/admin/promo-codes', payload);
                }
                this.$bvModal.hide('promo-modal');
                this.$bvToast.toast('Código guardado.', { title: 'Listo', variant: 'success' });
                await this.load();
            } catch (e) {
                const msg = e.response?.data?.msg || 'No se pudo guardar.';
                this.$bvToast.toast(msg, { title: 'Error', variant: 'danger' });
            } finally {
                this.saving = false;
            }
        },
        async toggle(id) {
            try {
                await axios.post(`/api/admin/promo-codes/${id}/toggle`);
                await this.load();
            } catch (e) {
                this.$bvToast.toast('No se pudo cambiar el estado.', { title: 'Error', variant: 'danger' });
            }
        },
        formatDate(d) {
            if (!d) return '—';
            return String(d).substring(0, 10);
        },
    },
};
</script>
